import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    CarrierCreatePayloadT,
    CarrierTripartiteAgreementPayload,
    CarrierUpdatePayloadT,
    CarriersCreateCarrierResponseT,
    CarriersDownloadExcelPayloadT,
    CarriersDownloadExcelResponseT,
    CarriersGetCarrierResponseT,
    CarriersGetContractInfoResponseT,
    CarriersGetListResponseT,
    VehicleOwnerUpdateT,
} from '../types/carriers.types'

export class CarriersRepository {
    getList(params: any): Promise<AxiosResponse<CarriersGetListResponseT>> {
        return http.get('/cabinet/api/v2/carriers', { params })
    }

    getCarrier(carrier_id: number): Promise<AxiosResponse<CarriersGetCarrierResponseT>> {
        return http.get(`/cabinet/api/v2/carriers/${carrier_id}`)
    }

    getContractInformation(bin: string): Promise<AxiosResponse<CarriersGetContractInfoResponseT>> {
        return http.get(`/contract/api/contract/${bin}/bin`)
    }

    createCarrier(
        carrier_payload: CarrierCreatePayloadT
    ): Promise<AxiosResponse<CarriersCreateCarrierResponseT>> {
        return http.post('/cabinet/api/v2/carriers', carrier_payload)
    }

    updateCarrier(
        carrier_id: number,
        carrier_payload: CarrierUpdatePayloadT
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/carriers/${carrier_id}`, carrier_payload)
    }

    updateVehicleOwner(vehicle_owner_payload: VehicleOwnerUpdateT): Promise<AxiosResponse<void>> {
        const vehicle_id = vehicle_owner_payload
            ? vehicle_owner_payload.id || vehicle_owner_payload.companyId
            : null

        return http.put(`/cabinet/api/vehicle-owner/${vehicle_id}`, vehicle_owner_payload)
    }

    resendTo1C(carrier_id: number): Promise<AxiosResponse<void>> {
        return http.post(`/cabinet/api/v2/carriers/${carrier_id}/resend-one-c`, {})
    }

    addCarriersJira(): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/v2/carriers/store-via-jira', {})
    }

    exportExcel(
        params: CarriersDownloadExcelPayloadT
    ): Promise<AxiosResponse<CarriersDownloadExcelResponseT>> {
        return http.get('/cabinet/api/v2/carriers/export', {
            responseType: 'blob',
            params: { ...params },
        })
    }

    tripartiteAgreement(payload: CarrierTripartiteAgreementPayload): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/vehicle-owner/send-contract', payload)
    }
}
